module.exports = __webpack_public_path__ + "static/rivieradev-d28ba3579f0b7570e0e79f10d4afad50.png";